export const fixedSourceList = ['youtube', 'meta', 'instagram', 'twitter', 'kakao', 'notion', 'realworld'];
